import createReducer from "./../createReducer";
import { paymentHandlers } from "./handlers";
import { IPayments } from "./types";

export const payment: IPayments = {
    isError: false,
    isShowPaymentTypeField: false,
    isShowPromocodeField: false,
};

export default createReducer(payment, paymentHandlers);
